import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomTimestampAdapter extends NgbDateAdapter<number> {

  fromModel(value: number | string | null): NgbDateStruct {
    let date: Date;
    if (!value || Number(value) <= -1) {
      date = new Date();
    } else {
      date = new Date(Number(value));
    }
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };
  }

  toModel(date: NgbDateStruct | null): number | null {
    if (!date) {
      return new Date().getTime();
    }

    const finalDate: Date = new Date(date.year, date.month - 1, date.day);
    return finalDate.getTime();
  }
}
